import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { getAllAnswers } from '@utils/onboardingStorage'
import { useTranslation } from 'react-i18next'

export default function ObstacleEmpathyPage() {
  const { t } = useTranslation()
  const allAnswers = getAllAnswers()
  const obstacle = allAnswers.obstacle?.answer_key

  const isEmotional = obstacle === 'Emotional attachment'
  const isNoTime = obstacle === 'No time or energy'

  const headingKey = isEmotional
    ? 'pages.onboarding.v2.obstacleEmpathy.emotional.heading'
    : isNoTime
      ? 'pages.onboarding.v2.obstacleEmpathy.noTime.heading'
      : 'pages.onboarding.v2.obstacleEmpathy.default.heading'
  const textKey = isEmotional
    ? 'pages.onboarding.v2.obstacleEmpathy.emotional.text'
    : isNoTime
      ? 'pages.onboarding.v2.obstacleEmpathy.noTime.text'
      : 'pages.onboarding.v2.obstacleEmpathy.default.text'

  return (
    <FeedbackPage
      emoji="💝"
      heading={t(headingKey)}
      text={t(textKey)}
      onSubmit={() => {}}
    />
  )
}
